module.exports = __webpack_public_path__ + "notes-at-icon-192.png?778254b28c71372a275c9fbb82dbc3a4";